import React, { useState, useEffect } from "react";
import { Row, Col, ListGroup, ListGroupItem } from "reactstrap";
import { useTranslation } from "react-i18next";
import "../styles/about.css";

import imgFeel from "../assets/images/5giacquan.png";
import heroFarmer from "../assets/images/hero-farmer.png";
import imgCacao from "../assets/images/hatCacao.png";
import imgFactory from "../assets/images/factory.png";
import imgComboHenk from "../assets/images/comboHenkBochat.png";
import imgComboMekong from "../assets/images/comboMekong.png";
import timeline from "../assets/images/timeline.png";
import arrowDown from "../assets/images/arrowDown.png";
import imgFlow from "../assets/images/quy trình 1.png";
import heroFarmerEn from "../assets/images/hero-farmer-en.png";
import heroFarmerMobile from "../assets/images/hero-farmerMobile-vn.jpg";
import heroFarmerMobileEn from "../assets/images/hero-farmerMobile-en.jpg";
import timelineEn from "../assets/images/timeline_en.png";
import imgFeelEn from "../assets/images/5giacquan_en.png";
import imgCacaoBean from "../assets/images/cacao-bean.png";
import imgRoasting from "../assets/images/roasting.png";
import imgWinnowing from "../assets/images/winnowing-grinding.png";
import imgConching from "../assets/images/conching-tempering.png";
import imgMoulding from "../assets/images/moulding.png";
import imgFinishProduct from "../assets/images/finished-product.png";
import imgComboMekongMobile from "../assets/images/comboMekongMobile.png";
const About = () => {
  const { t, i18n } = useTranslation();

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 567);
  const [isMobileSmall, setIsMobileSmall] = useState(window.innerWidth <= 500);
  const [isTablet, setIsTablet] = useState(window.innerWidth <= 899);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 567);
      setIsTablet(window.innerWidth <= 899);
      setIsMobileSmall(window.innerWidth <= 500);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Select images based on language
  const heroImage = i18n.language === "en" ? heroFarmerEn : heroFarmer;
  const heroImageMobile = i18n.language === "en" ? heroFarmerMobileEn : heroFarmerMobile;
  const timelineImage = i18n.language === "en" ? timelineEn : timeline;
  const feelImage = i18n.language === "en" ? imgFeelEn : imgFeel;

  return (
    <div className="about-page">
      {isMobileSmall ? (
        <section className="about__hero">
          <img src={heroImageMobile} alt="About Hero" className="img_about_hero" />
          <div className="icon_arrow_down">
            <img src={arrowDown} alt="" />
          </div>
        </section>
      ) : (
        <section className="about__hero">
          <img src={heroImage} alt="About Hero" className="img_about_hero" />
          <div className="icon_arrow_down">
            <img src={arrowDown} alt="" />
          </div>
        </section>
      )}

      <section className="about__content container">
        <div className="about__desc">
          <h3 style={{ marginBottom: "0" }}>{t("about_you_know")}</h3>

          <h3 style={{ marginBottom: "35px" }}>{t("about_each_cocoa_bean")}</h3>
          <p>
            {t("about_journey_begin")} <br />
            <br />
            {t("about_mekongzone")}
          </p>
        </div>
        {isMobile ? (
          <div className="about__questions">
            <div className="about__question">
              <img src={imgCacao} alt="" />
              <div className="question">
                <h1>WHY</h1>
                <p>{t("about_why")}</p>
              </div>
            </div>
            <div className="about__question">
              <img src={imgFactory} alt="" />
              <div className="question">
                <h1>HOW</h1>
                <p>{t("about_how")}</p>
              </div>
            </div>
            <div className="about__question">
              <img src={imgComboHenk} alt="" />
              <div className="question">
                <h1>WHAT</h1>
                <p>{t("about_what")}</p>
              </div>
            </div>
          </div>
        ) : (
          <div className="about__questions">
            <div className="about__question">
              <img src={imgCacao} alt="" />
              <div className="question">
                <h1>WHY</h1>
                <p>{t("about_why")}</p>
              </div>
            </div>
            <div className="about__question">
              <div className="question">
                <h1>HOW</h1>
                <p>{t("about_how")}</p>
              </div>
              <img src={imgFactory} alt="" />
            </div>
            <div className="about__question">
              <img src={imgComboHenk} alt="" />
              <div className="question">
                <h1>WHAT</h1>
                <p>{t("about_what")}</p>
              </div>
            </div>
          </div>
        )}
        <div className="about__flow">
          <div className="title">
            <h1>"BEAN-TO-BAR"</h1>
            <p>{t("about_how_chocolate")}</p>
          </div>
          <Row>
            <Col lg="2" className="flow__detail">
              <img src={imgCacaoBean} alt="" />
              <div className="flow__detail__content">
                <h3>{t("about_cocoa")}</h3>
                <p>{t("about_cocoa_detail")}</p>
              </div>
            </Col>
            <Col lg="2" className="flow__detail">
              <img src={imgRoasting} alt="" />
              <div className="flow__detail__content">
                <h3>{t("about_roasted_seeds")}</h3>
                <p>{t("about_roasted_seeds_detail")}</p>
              </div>
            </Col>
            <Col lg="2" className="flow__detail">
              <img src={imgWinnowing} alt="" />
              <div className="flow__detail__content">
                <h3>{t("about_shell_grind")}</h3>
                <p>{t("about_shell_grind_detail")}</p>
              </div>
            </Col>
            <Col lg="2" className="flow__detail">
              <img src={imgConching} alt="" />
              <div className="flow__detail__content">
                <h3>{t("about_mix_well")}</h3>
                <p>{t("about_mix_well_detail")}</p>
              </div>
            </Col>
            <Col lg="2" className="flow__detail">
              <img src={imgMoulding} alt="" />
              <div className="flow__detail__content">
                <h3>{t("about_pour_mold")}</h3>
                <p>{t("about_pour_mold_detail")}</p>
              </div>
            </Col>
            <Col lg="2" className="flow__detail">
              <img src={imgFinishProduct} alt="" />
              <div className="flow__detail__content">
                <h3>{t("about_finished_product")}</h3>
                <p>{t("about_finished_product_detail")}</p>
              </div>
            </Col>
          </Row>
        </div>
        <div className="about__commit">
          <div className="title">
            <h1>{t("about_commit")}</h1>
            <p>{t("about_from_heart")}</p>
          </div>
          <img src={timelineImage} alt="" />
        </div>
        {isMobile ? (
          <div className="about__mekong-taste">
            <div className="left__content">
              <h3 className="title">THE TASTE OF DISCOVERY</h3>
              <div>
                <img src={feelImage} alt="" />
                <img src={imgComboMekongMobile} alt="" />
              </div>
              <p>{t("about_the_taste_of_discovery_detail")}</p>
              <button>{t("about_discovery")}</button>
            </div>
          </div>
        ) : isTablet ? (
          <div className="about__mekong-taste">
            <div className="left__content">
              <h3 className="title">THE TASTE OF DISCOVERY</h3>
              <div>
                <img src={feelImage} alt="" />
                <img src={imgComboMekong} alt="" className="img__comboMekong" />
              </div>
              <p>{t("about_the_taste_of_discovery_detail")}</p>
              <button style={{color: "#1d1d1b"}}>{t("about_discovery")}</button>
            </div>
          </div>
        ) : (
          <Row className="about__mekong-taste">
            <Col className="left__content" lg="3">
              <h3 className="title">THE TASTE OF DISCOVERY</h3>
              <img src={feelImage} alt="" />
              <p>{t("about_the_taste_of_discovery_detail")}</p>
              <button style={{color: "#1d1d1b"}}>{t("about_discovery")}</button>
            </Col>
            <Col className="right__content" lg="6">
              <img src={imgComboMekong} alt="" />
            </Col>
          </Row>
        )}
      </section>
    </div>
  );
};

export default About;
